import { render, staticRenderFns } from "./ManageService.vue?vue&type=template&id=2b94bb2f&scoped=true&"
import script from "./ManageService.vue?vue&type=script&lang=js&"
export * from "./ManageService.vue?vue&type=script&lang=js&"
import style0 from "./ManageService.vue?vue&type=style&index=0&id=2b94bb2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94bb2f",
  null
  
)

export default component.exports